import React from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
    ConfigurationProvider,
    useConfiguration
} from './contexts/configuration/ConfigurationContext';
import {
    ReactPlugin,
    AppInsightsContext
} from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const AppWithMsal = () => {
    const { msalInstance, spaConfiguration } = useConfiguration();
    var reactPlugin = new ReactPlugin();

    var appInsights = new ApplicationInsights({
        config: {
            connectionString: spaConfiguration.appInsightsConnectionString,
            enableCorsCorrelation: true,
            enableRequestHeaderTracking: true,
            enableResponseHeaderTracking: true,
            enableAutoRouteTracking: true,
            extensions: [reactPlugin]
        }
    });

    appInsights.loadAppInsights();

    return (
        <>
            {msalInstance ? (
                <AppInsightsContext.Provider value={reactPlugin}>
                    <App pca={msalInstance} />
                </AppInsightsContext.Provider>
            ) : (
                <></>
            )}
        </>
    );
};

const AppRoot = () => {
    return (
        <ConfigurationProvider>
            <AppWithMsal />
        </ConfigurationProvider>
    );
};

export default AppRoot;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
